// tslint:disable: indent

export interface TaUserData {
    email: string;
    fullName: string;
    company: string;
}

export interface TaButtonProps {
    text: string;
    value: string;
    loading?: boolean;
    onUpdateStep: () => void;
}

export interface TaQuestionData {
    question: string;
    step: number;
    subject: string;
    subjectIcon: string;
    buttons: TaButtonProps[];
    topic: string;
    questionNumber: number;
}

export interface TaButtonProps {
    text: string;
    value: string;
    loading?: boolean;
    onUpdateStep: () => void;
}

export interface TaAnswerData {
    subjectIcon: any;
    answer: string;
    text: string;
    score: number;
    icon: string;
    subject: string;
    topic: string;
}

export enum TaPhase {
    WELCOME = 'WELCOME',
    ASSESSMENT = 'ASSESSMENT',
    RESULTS = 'RESULTS'
}

export const WIX_ANSWERS_LOGO_WHITE = 'https://static.wixstatic.com/media/dba05e_b1eb7b6bff2d4b328c35d484a47a7dd0~mv2.png';
export const WIX_ANSWERS_LOGO_BLACK = 'https://static.wixstatic.com/media/dba05e_beb7541b130a4585b03138b5ea20b913~mv2.png';
export const TA_QUESTIONS_PREVIEW_BG_IMG = 'https://static.wixstatic.com/media/dba05e_d1b943fa548f4d84b89cac7f2e1c9299~mv2.png';
export const TA_QUESTIONS_PREVIEW_IMG = 'https://static.wixstatic.com/media/dba05e_3bd327d007fe4f9eb8cc475214bd3108~mv2.png';
export const PRODUCTIVITY_ICON_BLACK = 'https://static.wixstatic.com/media/dba05e_5fdf2f88e2274f329eb51a76e3bf2a43~mv2.png';
export const PRODUCTIVITY_ICON_BLUE = 'https://static.wixstatic.com/media/dba05e_0b1d798cef4b4601812f0bea0883ee5b~mv2.png';
export const TECH_STACK_ICON_BLACK = 'https://static.wixstatic.com/media/dba05e_6f0f8a44745a4c7fb59d4cfd5dad191a~mv2.png';
export const TECH_STACK_ICON_BLUE = 'https://static.wixstatic.com/media/dba05e_1577147a435a4ab1ac1c7bd0fe8126e4~mv2.png';
export const SCALABILITY_ICON_BLACK = 'https://static.wixstatic.com/media/dba05e_fcee728d5e6c4c2a8fa1c549d14aaa83~mv2.png';
export const SCALABILITY_ICON_BLUE = 'https://static.wixstatic.com/media/dba05e_70d497fc02a249778c97b5321bb0d2ba~mv2.png';
export const INSIGHT_ICON_BLACK = 'https://static.wixstatic.com/media/dba05e_2aa1dff0284342b2afea468ad8e62b23~mv2.png';
export const INSIGHT_ICON_BLUE = 'https://static.wixstatic.com/media/dba05e_244b4da7565e44f483bc1d568ff2e0b0~mv2.png';
export const CX_LIBRARY_LINK = 'https://www.wixanswers.com/cx-library';
export const CX_LIBRARY_IMG = 'https://static.wixstatic.com/media/dba05e_5f13838af713442192a3046381627fcf~mv2.png';
export const SUPPORT_LEADERS_CHALLENGES_LINK = 'https://www.wixanswers.com/support-leaders-whitepaper-2020';
export const SUPPORT_LEADERS_CHALLENGES_IMG = 'https://static.wixstatic.com/media/dba05e_006a33d0671047e8b8af33f40f814479~mv2.png';
export const BUYERS_GUIDE_LINK = 'https://info.wixanswers.com/buyers-guide.html';
export const BUYERS_GUIDE_IMG = 'https://static.wixstatic.com/media/dba05e_578035065602474591318628e3a6320b~mv2.png';
export const LEARN_MORE_ICON = 'https://static.wixstatic.com/media/dba05e_1991b521c73b4e10b2cc3e0805bb6f28~mv2.png';
export const DOWNLOAD_NOW_ICON = 'https://static.wixstatic.com/media/dba05e_44784dac813643c19cc37e93fc1612df~mv2.png';
